module.exports = __webpack_public_path__ + "static/media/SendGrid.5ec3c3e5.ico";